import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class LaunchService {
    readonly samlRoute: string = '/api/trust/saml';

    getWorkflowData(queryParams: string, handleSuccess: Function): AxiosPromise {
        return apiService.get('/api/directory/applications/LaunchWorkflow' + queryParams, {
            local: true,
            onSuccess: handleSuccess
        })
            .catch();
    };

    postSaml(body: any, handleSuccess: Function): AxiosPromise {
        return apiService.post(
            this.samlRoute,
            body,
            {
                onSuccess: handleSuccess,
                local: true
            })
            .catch();
    };

    getSaml(queryParams: string, handleSuccess: Function): AxiosPromise {
        return apiService.get(
            this.samlRoute + queryParams,
            {
                local: true,
                onSuccess: handleSuccess
            })
            .catch();
    };

    getTrustDetect(queryParams: string, handleSuccess: Function): AxiosPromise {
        return apiService.get('/api/trust/detect' + queryParams,
            {
                local: true,
                onSuccess: handleSuccess
            })
            .catch();
    }

    getWsFederation(queryParams: string, handleSuccess: Function): AxiosPromise {
        return apiService.get('/api/trust/wsfed' + queryParams,
            {
                local: true,
                onSuccess: handleSuccess
            })
            .catch();
    }
}

export const launchService = new LaunchService();
